import React, { useCallback, useEffect, useState } from 'react';
import { Input, Modal } from 'antd';
import * as FaIcons from 'react-icons/fa';
import './styles.css';
import useIconPicker from './useIconPicker';
import { urlIconeModuloImagem } from '../../services/request/urls';

interface IconPickerProps {
    value?: number;
    onChange?: (icon: number) => void;
    name?: string;
}

const IconPicker: React.FC<IconPickerProps> = ({ value, onChange, name }) => {

    const {
        iconesModulo,
        loadingData,
        selectedIcon,
        setVisible,
        visible,
        searchTerm,
        setSearchTerm,
        filteredIcons,
        handleSelect
    } = useIconPicker({onChange, value});

    return (
        <div>
            <Input
                readOnly
                addonBefore={
                    selectedIcon ? <img width={20} src={urlIconeModuloImagem + selectedIcon.file} alt={selectedIcon.nome} /> : null
                }
                value={selectedIcon?.nome}
                onClick={() => setVisible(true)}
                placeholder="Selecione um ícone"
                suffix={<FaIcons.FaSearch />}
            />
            <input type="hidden" name={name} value={selectedIcon?.id} />

            <Modal
                title="Escolha um ícone"
                open={visible}
                width={800}
                onCancel={() => setVisible(false)}
                footer={null}
            >
                <div style={{ margin: '12px' }}>
                    <Input
                        placeholder="Pesquisar..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div
                        style={{
                            maxHeight: '400px',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 2fr))',
                            gap: '20px',
                            marginTop: '12px'
                        }}
                    >
                        {filteredIcons.sort((a, b) => a.nome.localeCompare(b.nome)).map((icone, index) => {
                            return (
                                <div
                                    key={index}
                                    onClick={() => handleSelect(icone.nome)}
                                    style={{
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        height: '80px',
                                        borderRadius: '8px',
                                        border: icone.nome === selectedIcon?.nome
                                            ? '1px solid #1677ff'
                                            : '1px solid transparent',
                                    }}
                                >
                                    <img
                                        src={urlIconeModuloImagem + icone.file}
                                        alt={icone.nome}
                                        style={{
                                            width: 50,
                                            height: 50,
                                            objectFit: 'contain',
                                        }}
                                    />
                                    <p
                                        style={{
                                            textAlign: 'center',
                                            fontSize: '11px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'clip',
                                            marginTop: '3px',
                                        }}
                                    >
                                        {icone.nome}
                                    </p>
                                </div>

                            );
                        })}
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default IconPicker;
